export enum TipoDocumentoExportarEnum {
  TXT = 0,
  XLSX = 1,
  PDF = 2,
  DOCX = 3,
  CSV = 4,
}

const descricao = new Map<TipoDocumentoExportarEnum, string>([
  [TipoDocumentoExportarEnum.TXT, "TXT"],
  [TipoDocumentoExportarEnum.XLSX, "XLSX"],
  [TipoDocumentoExportarEnum.PDF, "PDF"],
  [TipoDocumentoExportarEnum.DOCX, "DOCX"],
  [TipoDocumentoExportarEnum.CSV, "CSV"],
]);

export class TipoDocumentoExportarComponent {
  static getDescricao(valor: TipoDocumentoExportarEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): { valor: TipoDocumentoExportarEnum, descricao: string }[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({ valor, descricao }));
  }

  static getApenasPlanilhas(): { valor: TipoDocumentoExportarEnum, descricao: string }[] {
    const formatosPermitidos = [TipoDocumentoExportarEnum.XLSX, TipoDocumentoExportarEnum.CSV];

    return formatosPermitidos.map(valor => ({
      valor,
      descricao: this.getDescricao(valor)
    }));
  }

}
